import React from "react";
import "../assets/css/clockcard.css"; // Ensure styling is imported
import { BsCalendarCheck, BsBoxArrowRight } from "react-icons/bs";
import Loader from "./Loader";
import { formatDateTimeDisplay } from "../utils/common";

const ClocksCard = ({
  // firstClockIn = "09:14 AM",
  // clockIn = "09:14 AM",
  // clockOut = "--:--",
  // workingHours = "00:00",
  // breakHours = "00:00",
  // todayDate = "04 Jul 2026",
  // onClockOut,
  firstClockIn,
  clockIn,
  clockOut,
  workingHours,
  breakHours,
  /* ISO timestamp of the last sign-in, or null. */
  lastLoginAt,
  /* { Break, Lunch, "Be right back" } -> { hhmm, spells, ... }, from
     /dashboard/break-breakdown. Optional: without it the cell shows the single
     total it always showed. */
  breakBreakdown,
  todayDate,
  onClockOut,
  onClockIn,
  isClockIn,
  loading,
  
}) => {
   if (loading) {
    return (
      <div
        className="attendance-card"
        style={{
          minHeight: "150px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader inline variant="profile" />
      </div>
    );
  }
  return (
    <div className="attendance-card">
      <div className="attendance-left">
        <div className="attendance-icon">
          <BsCalendarCheck />
        </div>

        <div className="attendance-info"> 
          {/* <h6 className="attendance-title">
            Today's Attendance
          </h6> */}
<div className="attendance-row">
          <span className="attendance-label">First Clock In</span>

          <h3 className="attendance-time">{firstClockIn}</h3>

          <p className="attendance-date">{todayDate}</p>
          </div>
        </div>
      </div>
      <div className="attendance-divider"></div>

      {/* Clock In */}
            {/* <div className="attendance-stats"> */}
 
      <div className="attendance-item clockin">
        <span className="attendance-item-label">Clock In</span>

        <h5 className="attendance-item-value">{clockIn}</h5>
      </div>

      <div className="attendance-divider"></div>

      {/* Clock Out */}
      <div className="attendance-item clockout">
        <span className="attendance-item-label">Clock Out</span>

        <h5 className="attendance-item-value">{clockOut}</h5>
      </div>

      <div className="attendance-divider"></div>

      {/* Working Hours */}
      <div className="attendance-item workinghours">
        <span className="attendance-item-label">Working Hours</span>

        <h5 className="attendance-item-value">{workingHours}</h5>
      </div>

      {/* Sign-in time, next to the clock rather than instead of it.
          They are different facts and were being confused for one: somebody
          on the clock since 11:23 who signs in at 16:12 saw only 11:23, and
          reasonably read it as the app ignoring the sign-in. Signing in does
          not re-punch when you never clocked out — correct, since that would
          invent a break — so the sign-in needs its own place to be seen. */}
      {lastLoginAt && (
        <>
          <div className="attendance-divider"></div>
          <div className="attendance-item">
            <span className="attendance-item-label">Last Login</span>
            <h5 className="attendance-item-value">
              {formatDateTimeDisplay(lastLoginAt, "hh:mm A", "--:--")}
            </h5>
          </div>
        </>
      )}

      <div className="attendance-divider"></div>
      <div className="attendance-item breakhours">
        <span className="attendance-item-value">Break Hours</span>
        <h5 className="attendance-item-value">{breakHours}</h5>

        {/* The same total, split by why you were away.
            An hour of lunch and six five-minute breaks are the same number
            here and nothing like the same day, and the reason was already on
            every punch — it just had nowhere to be read.

            A reason with no time is dropped rather than shown as 00:00: three
            zeroes under a zero total is noise, and on a normal morning two of
            the three are always zero. */}
        {breakBreakdown && (
          <div className="break-split">
            {[
              { key: "Break", label: "Break", tone: "amber" },
              { key: "Lunch", label: "Lunch", tone: "red" },
              { key: "Be right back", label: "BRB", tone: "blue" },
            ]
              .filter((r) => (breakBreakdown[r.key]?.seconds ?? 0) > 0)
              .map((r) => {
                const t = breakBreakdown[r.key];
                return (
                  <span
                    key={r.key}
                    className={`break-split__item break-split__item--${r.tone}`}
                    title={`${r.label}: ${t.hhmm} over ${t.spells} ${
                      t.spells === 1 ? "spell" : "spells"
                    }${t.open ? " (one still running)" : ""}`}
                  >
                    <em>{r.label}</em>
                    {t.hhmm}
                  </span>
                );
              })}
          </div>
        )}
      </div>
      {/* Clock In/Out button moved to the top header (see HeaderClockButton). */}
    </div>
  );
};

export default ClocksCard;
